var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h3',[_vm._v("Run "+_vm._s(_vm.$route.params.id))]),_c('process-logs',{attrs:{"run_id":_vm.$route.params.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }